"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimaryAltButtonFullWidth = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const sdsButtons_1 = require("../sdsButtons");
const PrimaryAltButtonFullWidth_module_css_1 = __importDefault(require("./PrimaryAltButtonFullWidth.module.css"));
/**
 * Primary alt button which takes full width of parent
 */
function PrimaryAltButtonFullWidth(props) {
    return (0, jsx_runtime_1.jsx)(sdsButtons_1.ButtonOrLink, { ...props, className: PrimaryAltButtonFullWidth_module_css_1.default.primaryAltButtonFullWidth });
}
exports.PrimaryAltButtonFullWidth = PrimaryAltButtonFullWidth;
//# sourceMappingURL=PrimaryAltButtonFullWidth.js.map